import { Component, Input, OnInit } from '@angular/core';
import { HttpPaymentService } from '../../apis/http-payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentProcessingStatus } from '../../types/payment/payment-processing-status';
import { SignalrPaymentStatusService } from '../../apis/signalr-payment-status.service';
import { PaymentRequest } from '../../types/payment/payment-request';

@Component({
  selector: 'app-payment-status',
  template: '',
  standalone: true
})
export class PaymentStatusComponent implements OnInit {
  @Input() request!: PaymentRequest;
  private stopPolling = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: HttpPaymentService,
    private notification: SignalrPaymentStatusService
  ) {}

  ngOnInit(): void {
    const transactionCorrelationId = this.route.snapshot.queryParamMap.get('reference')!;
    this.notification.poll(
      () => this.updateStatusFromApi(transactionCorrelationId),
      () => this.stopPolling
    );
  }

  async updateStatusFromApi(transactionCorrelationId: string) {
    let response = await this.api.getPaymentStatus(this.request.publicId, transactionCorrelationId);
    this.navigateToProcessed(transactionCorrelationId, response.paymentStatus);
  }

  navigateToProcessed(transactionCorrelationId: string, status: string) {
    if (status != PaymentProcessingStatus.pending) {
      this.stopPolling = true;
      this.router.navigate([this.request.publicId, transactionCorrelationId, 'processed', status], { replaceUrl: true });
    }
  }
}
